import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import AppShell from "../layouts/AppShell";
import { appModules } from "../components/global";
import { GET, POST, PUT, DELETE, loading, alert } from "../components/CustomComponent";

const DocumentModal = ({ show, onHide, editData, onSave }) => (
  <Modal show={show} onHide={onHide} centered size="lg">
    <Modal.Header closeButton className="bg-light border-0">
      <Modal.Title className="fw-bold h5 mb-0">
        {editData ? "แก้ไขเอกสาร" : "อัปโหลดเอกสารใหม่"}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <form className="row g-3">
        <div className="col-md-12">
          <label className="form-label">ชื่อเอกสาร</label>
          <input type="text" className="form-control" defaultValue={editData?.name || ""} placeholder="ระบุชื่อเอกสาร" />
        </div>
        <div className="col-md-6">
          <label className="form-label">หมวดหมู่</label>
          <select className="form-select" defaultValue={editData?.category || ""}>
            <option value="">เลือกหมวดหมู่</option>
            <option value="นโยบาย">นโยบาย</option>
            <option value="ทั่วไป">ทั่วไป</option>
          </select>
        </div>
        <div className="col-md-6">
          <label className="form-label">แนบไฟล์</label>
          <input type="file" className="form-control" />
        </div>
      </form>
    </Modal.Body>
    <Modal.Footer className="bg-light border-0">
      <button type="button" className="btn btn-secondary" onClick={onHide}>ยกเลิก</button>
      <button type="button" className="btn btn-primary" onClick={() => onSave({})}>บันทึกข้อมูล</button>
    </Modal.Footer>
  </Modal>
);

export default function Documents() {
  const { title, description } = appModules["documents"];
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [data, setData] = useState([]);

  const summaryCards = [
    { label: "เอกสารทั้งหมด", value: "24", color: "#0c76e5" },
    { label: "หมวดหมู่นโยบาย", value: "5", color: "#2fd5e4" },
    { label: "แบบฟอร์มคำขอ", value: "19", color: "#e5a93e" },
  ];

  const handleOpenModal = (data = null) => {
    setEditData(data);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setEditData(null);
    setShowModal(false);
  };

  const GetData = async () => {
    loading(true);
    let body = {};
    let result = await GET("v1/admin/documents", body);
    if (result?.status) {
      setData(result.data || []);
    }
    loading(false);
  };

  useEffect(() => {
    GetData();
  }, []);

  const CreateUpdate = async (formData) => {
    if (
      await alert("", "info", "ยืนยัน", "ยืนยันการบันทึกข้อมูลหรือไม่?", "ยืนยัน", "ยกเลิก")
    ) {
      loading(true);
      let uid = formData?.uid || editData?.uid;
      let body = { ...formData };

      let result = !uid
        ? await POST("v1/admin/documents", body)
        : await PUT("v1/admin/documents/" + uid, body);
        
      if (result?.status === true) {
        alert("", "success", "สำเร็จ", "ทำรายการสำเร็จแล้ว");
        GetData();
        handleCloseModal();
      } else {
        alert("", "warning", "แจ้งเตือน", result?.message || "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      }
      loading(false);
    }
  };

  const DeleteData = async (id) => {
    if (
      await alert("", "warning", "ลบรายการ", "ต้องการลบรายการนี้ใช่หรือไม่?", "ยืนยัน", "ยกเลิก")
    ) {
      loading(true);
      let result = await DELETE("v1/admin/documents/" + id, null);
      if (result?.status) {
        alert("", "success", "สำเร็จ", "ทำรายการสำเร็จแล้ว");
        GetData();
      }
      loading(false);
    }
  };

  return (
    <AppShell title={title} description={description}>
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-3">
        <div className="d-flex gap-2 filters-mobile-stack">
          <input type="text" className="form-control" placeholder="ค้นหาเอกสาร..." style={{ width: '250px', borderRadius: '12px' }} />
          <select className="form-select" style={{ width: '150px', borderRadius: '12px' }}>
            <option>ทุกหมวดหมู่</option>
            <option>นโยบาย</option>
            <option>แบบฟอร์ม</option>
          </select>
        </div>
        <button onClick={() => handleOpenModal()} className="btn btn-primary px-4">
          <i className="bi bi-cloud-arrow-up me-2"></i>อัปโหลดไฟล์
        </button>
      </div>

      <div className="row g-3 mb-4">
        {summaryCards.map((item) => (
          <div key={item.label} className="col-12 col-md-4">
            <div
              className="h-100 rounded-4 p-4 d-flex flex-column justify-content-center"
              style={{
                background: "linear-gradient(180deg, #ffffff 0%, #f2f9ff 100%)",
                border: "1px solid rgba(18, 125, 255, 0.10)",
                boxShadow: "0 14px 28px rgba(12, 118, 229, 0.06)",
              }}
            >
              <p className="small text-uppercase text-secondary mb-1">{item.label}</p>
              <h2 className="h2 mb-0 fw-bold" style={{ color: item.color }}>{item.value} <span className="h6 text-secondary fw-normal">ไฟล์</span></h2>
            </div>
          </div>
        ))}
      </div>

      <div
        className="rounded-4 p-3 bg-white"
        style={{
          border: "1px solid rgba(18, 125, 255, 0.10)",
          boxShadow: "0 4px 12px rgba(12, 118, 229, 0.04)",
        }}
      >
        <h5 className="mb-4 fw-semibold text-dark">ไฟล์และเอกสารส่วนกลาง</h5>
        <div className="table-responsive table-mobile-cards">
          <table className="table table-hover align-middle">
            <thead className="table-light">
              <tr>
                <th className="text-secondary fw-medium rounded-start">ชื่อเอกสาร</th>
                <th className="text-secondary fw-medium">หมวดหมู่</th>
                <th className="text-secondary fw-medium">วันที่อัปโหลด</th>
                <th className="text-secondary fw-medium text-center rounded-end">ดาวน์โหลด</th>
              </tr>
            </thead>
            <tbody>
              {['นโยบายบริษัท 2026.pdf', 'แบบฟอร์มเบิกค่าเดินทาง.docx', 'คู่มือใช้งานระบบ ParthenonTech.pdf'].map((doc, i) => (
                <tr key={i}>
                  <td data-label="ชื่อเอกสาร"><div className="fw-medium">{doc}</div></td>
                  <td data-label="หมวดหมู่">{i === 0 ? "นโยบาย" : "ทั่วไป"}</td>
                  <td data-label="วันที่อัปโหลด">20 ม.ค. 2026</td>
                  <td data-label="ดาวน์โหลด" className="text-center">
                    <button onClick={() => handleOpenModal({ name: doc, category: i === 0 ? "นโยบาย" : "ทั่วไป" })} className="btn btn-sm btn-outline-primary rounded-3 px-3 me-2" title="แก้ไข"><i className="fa-solid fa-pen" /></button>
                    <button className="btn btn-sm btn-outline-secondary rounded-3 px-3" title="ดาวน์โหลด"><i className="fa-solid fa-download" /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <DocumentModal show={showModal} onHide={handleCloseModal} editData={editData} onSave={CreateUpdate} />
    </AppShell>
  );
}